import { MovieRollIcon } from './MovieRollIcon';

/**
 * author: fraaalk
 * id 21D0F9FB-6814-4CE7-B37D-FC97EBF1D0D2
 * name movie-roll
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-roll.svg
 * tags
 * - Video / Movie 
 */
export const FilmReelIcon = MovieRollIcon;
export default FilmReelIcon